export const ru = {
    'continue-edit': 'Продолжить редактирование',
    'default-name': 'Новая группа креативов',
    ok: 'ОК',
    'previews-title': 'Предварительный просмотр креативов',
    'reset-smart-center': 'Установить смарт-центр',
    'show-all-previews': 'Показать все'
};
